import styled from "@emotion/styled";

export const ModalWrapper = styled("div")({
    backgroundColor: "#fff",
    padding: "24px 28px",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    borderRadius: "9px",
    border: "1px solid #d9d9d9",
    width: "90vw",
    maxWidth: "400px"
  });
  